// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@bg/App/Store/Reducers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomAppState) => {
    const { cartId } = state.pages.checkoutShipping;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const { isUpdatingCart } = state.pages.checkoutShipping;
    const cart = cartState.value;
    const erpSystemIsDown = (cart?.properties && cart?.properties?.erpSystemIsDown === "true") || false;
    return {
        cart,
        isLoading: !cartState.value || cartState.isLoading || isUpdatingCart,
        erpSystemIsDown,
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface CheckoutShippingCartTotalStyles {
    container?: InjectableCss;
    buttonsGridItem?: InjectableCss;
    continueButton?: ButtonPresentationProps;
}

export const cartTotalStyles: CheckoutShippingCartTotalStyles = {
    container: {},
    buttonsGridItem: {
        css: css``,
    },
    continueButton: {
        variant: "primary",
        css: css`
            width: 100%;
        `,
    },
};

const styles = cartTotalStyles;

const CheckoutShippingCartTotal: FC<Props> = ({ cart, isLoading, erpSystemIsDown }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.buttonsGridItem}>
                <Button
                    {...styles.continueButton}
                    type="submit"
                    disabled={isLoading || erpSystemIsDown}
                    data-test-selector="checkoutShippingCartTotalContinueButton"
                    aria-label={translate("Continue")}
                >
                    {translate("Continue")}
                </Button>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CheckoutShippingCartTotal),
    definition: {
        group: "XNGAGE" as any,
        allowedContexts: ["CheckoutShippingPage"],
        displayName: "Button Actions",
    },
};

export default widgetModule;
